<template>
  <div
    style="
      overflow: hidden;
      height: 100%;
      background-color: #f6f6f6;
      display: flex;
      flex-direction: column;
    "
  >
    <van-nav-bar
      left-text="返回"
      left-arrow
      van-nav-bar
      safe-area-inset-top
      @click-left="onBack"
    >
      <template #title>
        {{ $store.state.loginUser?.name }}
        <text v-if="$store.state.loginUser?.department_name">{{
          "/" + $store.state.loginUser?.department_name
        }}</text>
      </template>
    </van-nav-bar>
    <div
      style="flex: 1; padding: 0 10px; overflow-y: auto; margin-bottom: 10px"
    >
      <van-pull-refresh v-model="state.isRefresh" @refresh="onRefresh">
        <div
          style="
            background-color: #fff;
            border-radius: 10px;
            padding: 10px;
            position: relative;
            font-size: 13px;
            margin-top: 10px;
          "
        >
          <ul
            style="
              text-align: center;
              font-weight: 600;
              padding-bottom: 10px;
              border-bottom: 1px solid #f6f6f6;
            "
          >
            员工信息
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">姓名</li>
            {{
              state.salaryReocrd?.name
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">收款账户</li>
            {{
              state.salaryReocrd?.bank_account
            }}
          </ul>
        </div>
        <div
          style="
            background-color: #fff;
            border-radius: 10px;
            padding: 10px;
            position: relative;
            font-size: 13px;
            margin-top: 10px;
          "
        >
          <ul
            style="
              text-align: center;
              font-weight: 600;
              padding-bottom: 10px;
              border-bottom: 1px solid #f6f6f6;
            "
          >
            发薪信息
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">所属单位</li>
            {{
              state.salaryReocrd?.customer_name
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">发薪单位</li>
            {{
              state.salaryReocrd?.withholding_agent_name
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">发薪月份</li>
            {{
              state.salaryReocrd?.month
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">发放时间</li>
            {{
              state.salaryReocrd?.pay_date
            }}
          </ul>
          <ul style="display: flex; align-items: center">
            <li style="flex: 1; color: #a2a2a2">发放金额</li>
            <li
              style="
                font-size: 16px;
                display: flex;
                align-items: flex-end;
                font-weight: 600;
                color: #f00;
              "
            >
              <text
                style="font-size: 12px; margin-bottom: 1px; font-weight: 500"
                >￥</text
              >
              {{ $priceFormat(state.salaryReocrd?.money) }}
            </li>
          </ul>
        </div>
        <div
          style="
            background-color: #fff;
            border-radius: 10px;
            padding: 10px;
            position: relative;
            font-size: 13px;
            margin-top: 10px;
          "
        >
          <ul
            style="
              text-align: center;
              font-weight: 600;
              padding-bottom: 10px;
              border-bottom: 1px solid #f6f6f6;
            "
          >
            薪资明细
          </ul>
          <ul
            style="display: flex; align-items: center; line-height: 30px"
            v-for="item in state.payrollEmployee?.templateSortFields"
            :key="item"
          >
            <li style="flex: 1; color: #a2a2a2">{{ item.name }}</li>
            {{
              $priceFormat(state.payrollEmployee?.info[item.field])
            }}
          </ul>
          <!-- <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">岗位工资</li>
            {{
              $priceFormat(state.model?.a8)
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">补贴/津贴</li>
            {{
              $priceFormat(state.model?.a9)
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">绩效/提成</li>
            {{
              $priceFormat(state.model?.a10)
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">奖金</li>
            {{
              $priceFormat(state.model?.a11)
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">应发工资</li>
            {{
              $priceFormat(state.model?.a12)
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">社保</li>
            {{
              $priceFormat(state.model?.a13)
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">个税</li>
            {{
              $priceFormat(state.model?.a14)
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">服务费</li>
            {{
              $priceFormat(state.model?.a15)
            }}
          </ul>
          <ul style="display: flex; align-items: center; line-height: 30px">
            <li style="flex: 1; color: #a2a2a2">本月实发工资</li>
            {{
              $priceFormat(state.model?.a16)
            }}
          </ul> -->
        </div>
      </van-pull-refresh>
    </div>
    <van-button
      type="primary"
      style="width: calc(100% - 20px); margin: 0 10px 20px 10px"
      @click="onSubmit"
      v-if="state.model?.is_confirm == 0"
      >确认签收
    </van-button>
  </div>
</template>

<script>
import { onBeforeUnmount, onMounted, reactive } from "vue";
import { salary_detail, salary_confirm } from "@/http/api";
import { showConfirmDialog, showNotify } from "vant";
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {
      if (window.history && window.history.pushState) {
        history.pushState(null, null, document.URL);
        window.addEventListener("popstate", onBack, false);
      }

      onLoad();
    });

    const onLoad = () => {
      salary_detail(props.id).then((res) => {
        state.isRefresh = false;
        if (res.status == 200) {
          const { salaryReocrd, payrollEmployee } = res.data.data;
          state.salaryReocrd = salaryReocrd;
          state.payrollEmployee = payrollEmployee;
        }
      });
    };

    const onRefresh = () => {
      state.isRefresh = true;
      onLoad();
    };

    const onBack = () => {
      emit("close", state.refList);
    };

    onBeforeUnmount(() => {
      // 在组件销毁前移除事件监听
      window.removeEventListener("popstate", onBack);
    });

    const onSubmit = () => {
      showConfirmDialog({
        title: "签收确认",
        message: `点击“确认签收”，即正式确认您已安全无误地接收到本月的工资明细单，以此作为您个人对薪资信息的准确接收与认可的官方确认。`,
        allowHtml: true,
        confirmButtonText: "确认签收",
      }).then(() => {
        salary_confirm(props.id).then((res) => {
          if (res.status == 200) {
            showNotify({ type: "success", message: res.data.msg });
            emit("close", true);
          }
        });
      });
    };

    return { state, onLoad, onRefresh, onBack, onSubmit };
  },
};
</script>
<style scoped></style>
